import { StateUpdateFns } from 'ngrx-forms';
import { Action } from '@ngrx/store';
import { NgrxFormExtensionModel, HasNgrxForm } from '@app/common/ngrx-forms-extensions';
import { formKey } from './price-offer-reject-form.constant';
import { PriceOfferRejectFormValue, PriceOfferRejectFormState } from './price-offer-reject-form.model';

export const formModel = new NgrxFormExtensionModel<PriceOfferRejectFormValue>(formKey);

export const getFormKey = (id: string) => formModel.getKey(id);

export const formState = (id: string) => (
  defaultValues: Partial<PriceOfferRejectFormValue> = {},
  updateFns: StateUpdateFns<PriceOfferRejectFormValue> = {}
) => ({
  [getFormKey(id)]: formModel.createFormState(
    id,
    {
      messageText: undefined
    },
    defaultValues,
    updateFns
  )
});

export const applyFormReducer = <S extends HasNgrxForm>(
  state: S,
  action: Action,
  id: string,
  defaultSettings?: StateUpdateFns<PriceOfferRejectFormValue>
) => formModel.reduceAction(state, action, id, defaultSettings);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markAsSubmitted = (id: string, state: any) => formModel.markAsSubmitted(id, state);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markAsUnsubmitted = (id: string, state: any) => formModel.markAsUnsubmitted(id, state);
export const formSelector = (id: string) => formModel.selectState<PriceOfferRejectFormState>(id);
export const formValueSelector = (id: string) => formModel.selectValue(id);
export const updateGroupAction = (
  id: string,
  value: Partial<PriceOfferRejectFormValue>
) => formModel.updateGroupValue(id, value);
